export const TRANSACTION_COLUMNS = [
  {
    value: 'createdAt',
    label: 'Compra em'
  },
  {
    value: 'vendorName',
    label: 'Empresa'
  },
  {
    value: 'aut',
    label: 'Aut'
  },
  {
    value: 'doc',
    label: 'Doc'
  },
  {
    value: 'reservationCode',
    label: 'Reserva'
  },
  {
    value: 'paymentMethod',
    label: 'Pagamento'
  },
  {
    value: 'totalAmount',
    label: 'Valor'
  },
  {
    value: '',
    label: 'Multiponto'
  },
  {
    value: '',
    label: 'Estado'
  }
]
